/**
 * Monarch enum / dropdown fields often serialize as `{ value: "..." }` instead of a plain string.
 * Without unwrapping, URLs become `.../[object Object]/...` and Kore gets the wrong bundle or 404s.
 *
 * @param {unknown} raw
 * @returns {string | null} usable scalar, or null if not extractable
 */
export const unwrapMonarchScalar = (raw) => {
  if (raw == null) return null;
  if (typeof raw === "string") return raw;
  if (typeof raw === "number" && !Number.isNaN(raw)) return String(raw);
  if (typeof raw === "object" && !Array.isArray(raw)) {
    if (
      raw.value != null &&
      (typeof raw.value === "string" || typeof raw.value === "number")
    ) {
      return String(raw.value);
    }
    if (typeof raw.id === "string") return raw.id;
  }
  return null;
};

/**
 * @param {unknown} raw
 * @returns {string | undefined}
 */
export const coerceMonarchOptionalString = (raw) => {
  if (raw == null) return undefined;
  if (typeof raw === "string") return raw;
  const u = unwrapMonarchScalar(raw);
  return u != null ? u : undefined;
};

/**
 * Unwraps known enum-shaped keys on a shallow object (e.g. `proactive.type`).
 *
 * @param {Record<string, unknown> | null | undefined} obj
 * @param {string[]} keys
 * @returns {Record<string, unknown> | undefined}
 */
export const unwrapMonarchObjectScalars = (obj, keys) => {
  if (!obj || typeof obj !== "object") return undefined;
  const out = { ...obj };
  let changed = false;
  keys.forEach((k) => {
    if (k in out && out[k] != null) {
      const unwrapped = unwrapMonarchScalar(out[k]);
      if (unwrapped != null && unwrapped !== out[k]) {
        out[k] = unwrapped;
        changed = true;
      }
    }
  });
  return changed ? out : obj;
};
